
  import { css } from 'lit';
  export const styles = css`:host{--button-focus-arrow-color: var(--ig-carousel-button-focus-arrow-color, var(--ig-secondary-600));--ig-theme: material;--ig-theme-variant: light;--navigation-border-radius: var(--border-radius)}`;
  